import React from 'react';
import PropTypes from 'prop-types';

const ArrowDown = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg id="angle-down" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" {...other}>
      <path id="Shape" d="M0,0H20V20H0Z" fill="none" />
      <path id="Path_5269" data-name="Path 5269" d="M16.371,6.138,10.288,12.3,4.2,6.138a1.159,1.159,0,0,0-1.583,0l-.583.583a1.159,1.159,0,0,0,0,1.583l7.5,7.5a1.159,1.159,0,0,0,1.583,0l7.5-7.5a1.159,1.159,0,0,0,0-1.583l-.583-.583A1.267,1.267,0,0,0,16.371,6.138Z" transform="translate(-0.288 -0.971)" fill={color} />
    </svg>
  );
}

ArrowDown.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

ArrowDown.defaultProps = {
  color: '#6a728a',
  width: 20,
  height: 20,
};

export default ArrowDown;




// WEBPACK FOOTER //
// ./src/components/Icons/ArrowDown.jsx